/* Peggy Bakes — fit the "GLUTEN-FREE" eyebrow to the exact ink width of
   "GRANOLA," on the line below it.

   Doing this with a hard-coded letter-spacing only works if the font renders
   with identical metrics everywhere, which it does not (fallback fonts, OS
   rendering, zoom). So measure at runtime instead and solve for the tracking.

   ink width = glyphs + (chars - 1) * letter-spacing
   The block is right-aligned and letter-spacing leaves a trailing gap after
   the last character, so it is also nudged right by (ls - headlineLs).
   That nudge is halved: a negative margin on the paragraph also shrinks its
   fit-content parent, so the shift lands twice. */
(function () {
  var EYEBROW = '[class*="__text_pbeyebrow"] p';
  var HEADLINE = '[class*="__text_YLPk4p"] p';

  function textNode(el) {
    for (var i = 0; i < el.childNodes.length; i++) {
      var n = el.childNodes[i];
      if (n.nodeType === 3 && n.textContent.trim()) return n;
    }
    return null;
  }

  function fit() {
    var eb = document.querySelector(EYEBROW);
    var hl = document.querySelector(HEADLINE);
    if (!eb || !hl) return;
    if (window.getComputedStyle(eb).display === 'none') return;

    var en = textNode(eb);
    var hn = textNode(hl);
    if (!en || !hn) return;

    var chars = en.textContent.trim().length;
    var gaps = chars - 1;
    if (gaps < 1) return;

    var hls = parseFloat(window.getComputedStyle(hl).letterSpacing) || 0;

    // Ink width of the headline's first line ("GRANOLA,"), minus its own
    // trailing letter-space.
    var hr = document.createRange();
    hr.selectNodeContents(hl);
    var rects = hr.getClientRects();
    var first = null;
    for (var i = 0; i < rects.length; i++) {
      if (rects[i].width > 1) { first = rects[i]; break; }
    }
    if (!first) return;
    var target = first.width - hls;

    // Measure the eyebrow's bare glyph width with tracking removed.
    eb.style.letterSpacing = '0px';
    eb.style.marginInlineEnd = '0px';
    var er = document.createRange();
    er.selectNodeContents(eb);
    var glyphs = er.getBoundingClientRect().width;
    if (!glyphs) return;

    var ls = (target - glyphs) / gaps;
    if (!isFinite(ls) || ls < 0) ls = 0;

    eb.style.letterSpacing = ls + 'px';
    eb.style.marginInlineEnd = (-(ls - hls) / 2) + 'px';
  }

  function schedule() {
    window.clearTimeout(window.__pbHeroFit);
    window.__pbHeroFit = window.setTimeout(fit, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fit);
  } else {
    fit();
  }
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fit).catch(function () {});
  }
  window.addEventListener('resize', schedule);
  window.addEventListener('load', fit);
})();